import {  createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var UpdateBannerRes;
export const UpdateBannerTodo = createAsyncThunk('UpdateBanner', async (data) => {
    // console.log("data", data)
    try {
        const res = await axios({
            method: "Post",
            url: process.env.REACT_APP_API_URL +'banner_data',
            data: data,
            headers: { "Content-Type":"multipart/form-data"  , "Authorization": 'Bearer ' + localStorage.getItem('user_token') }
        })
        return UpdateBannerRes = res.data
        
    } catch (error) {
        return UpdateBannerRes = error.response.data
    }
})
